import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import JSZip from "jszip";
import FileSaver from "file-saver";
import { Link } from "react-router-dom";
import moment from "moment";
import { pdf } from "@react-pdf/renderer";
import _ from "lodash";
import { Typography, Button, Skeleton, DataTable, makeStyles, Grid, SMPopover, DialogViewInvoice, Dialog, ToolbarSelect, InvoicesData, FilterInvoicesList, DialogCertificatePassword } from "../../../..";
import { MyDocument } from "../../../../core/reactPdf";
import { ButtonGroup } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    columnsContainer: {
      display: "flex",
      "justify-content": "space-between"
    },
    column: {
      display: "flex",
      flexDirection: "column",
      "align-items": "center",
      "min-height": "300px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    mr30: {
      margin: "30px"
    },
    title: {
      "text-align": "center",
      "font-weight": "bold",
      background: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      width: "300px",
      "border-radius": "4px 4px 0px 0px",
      padding: "5px 15px"
    },
    content: {
      width: "300px",
      background: "#7D7D7D",
      padding: "15px"
    },
    layoutOptions: {
      display: "flex",
      "justify-content": "flex-end",
      width: "97%",
      padding: "10px 0px"
    }
  };
});

var InvoiceList = function InvoiceList(_ref) {
  var invoices = _ref.invoices,
      compareInvoices = _ref.compareInvoices,
      invoice_pdf = _ref.invoice_pdf,
      columns = _ref.columns,
      translation = _ref.translation,
      title = _ref.title,
      getInvoicePdf = _ref.getInvoicePdf,
      editStatus = _ref.editStatus,
      sendNotification = _ref.sendNotification,
      handleAmendInvoice = _ref.handleAmendInvoice,
      handleDuplicateInvoice = _ref.handleDuplicateInvoice,
      handleDeleteInvoice = _ref.handleDeleteInvoice,
      handleSelectInvoicesToDownload = _ref.handleSelectInvoicesToDownload,
      handleSelectInvoicesToSend = _ref.handleSelectInvoicesToSend,
      checkPassword = _ref.checkPassword,
      invoicesToPDF = _ref.invoicesToPDF,
      dashboard = _ref.dashboard,
      franchise = _ref.franchise,
      centralUser = _ref.centralUser,
      locale = _ref.locale,
      getFilteredInvoices = _ref.getFilteredInvoices,
      _ref$groupedByCategor = _ref.groupedByCategory,
      groupedByCategory = _ref$groupedByCategor === void 0 ? false : _ref$groupedByCategor,
      year = _ref.year,
      handleChangeYear = _ref.handleChangeYear,
      handleSelectYears = _ref.handleSelectYears,
      billingCentral = _ref.billingCentral,
      _ref$isCentralFranchi = _ref.isCentralFranchiseView,
      isCentralFranchiseView = _ref$isCentralFranchi === void 0 ? false : _ref$isCentralFranchi,
      totals = _ref.totals;
  // console.log("InvoiceList locale", locale);
  var classes = useStyles();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openView = _useState2[0],
      setOpenView = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDeleteInvoice = _useState4[0],
      setOpenDeleteInvoice = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedInvoice = _useState6[0],
      setSelectedInvoice = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedId = _useState8[0],
      setSelectedId = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      centralView = _useState10[0],
      setCentralView = _useState10[1];
  /* ----View */


  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openPassword = _useState12[0],
      setOpenPassword = _useState12[1];

  useEffect(function () {
    dashboard && setCentralView(Object.keys(dashboard).indexOf("campus") > 0 || Object.keys(dashboard).indexOf("academies") > 0 || Object.keys(dashboard).indexOf("events") > 0);
  }, [dashboard]);
  useEffect(function () {
    if (invoicesToPDF && invoicesToPDF.length > 0) {
      var zip = new JSZip();
      Promise.all(invoicesToPDF.map(function (invoice) {
        var document = /*#__PURE__*/React.createElement(MyDocument, {
          data: invoice,
          translation: translation ? translation.dialogs.view_invoice.pdf.document : null
        });
        return pdf(document).toBlob().then(function (blob) {
          // console.log("invoice id", invoice._id);
          // console.log("invoice id", invoice.date);
          // console.log("invoice id", invoice.docnumber);
          return invoicesToPDF.length > 1 ? zip.file("".concat(moment(invoice.date).format("M"), "/").concat(invoice.docnumber.replace("/", "-"), ".pdf"), blob) : FileSaver.saveAs(blob, invoice.docnumber + ".pdf");
        });
      })).then(function (x) {
        if (invoicesToPDF.length > 1) zip.generateAsync({
          type: "blob"
        }).then(function (content) {
          FileSaver.saveAs(content, "invoices.zip");
        });
      });
    }
  }, [invoicesToPDF]);
  var options = {
    filter: false,
    selectableRows: "multiple",
    // filterType: "dropdown",
    responsive: "stacked",
    rowsPerPage: 100,
    customToolbarSelect: function customToolbarSelect(selectedRows, displayData, setSelectedRows) {
      return /*#__PURE__*/React.createElement(ToolbarSelect, {
        variant: "invoice",
        selectedRows: selectedRows,
        displayData: displayData,
        franchise: franchise,
        handleClick: function handleClick(type, rows, displayData) {
          rows && rows.data ? handleSelectInvoices(type, rows.data, displayData) : console.log("error data rows");
        }
      });
    }
  };

  var handleItemViewInvoice = function handleItemViewInvoice(item, id) {
    // console.log("handleItemViewInvoice", item, id);
    if (!openView) {
      var invoice = invoices.find(function (invoice) {
        return invoice._id === id;
      }); // console.log("handleItemViewInvoice invoice", invoice);

      setSelectedInvoice(invoice);
    } else {
      setSelectedInvoice(null);
    }

    getInvoicePdf(id);
    setOpenView(true);
  };

  var handleItemAmendInvoicePopover = function handleItemAmendInvoicePopover(item, id) {
    handleAmendInvoice(id);
  };

  var handleItemDownloadFaceInvoicePopover = function handleItemDownloadFaceInvoicePopover(item, id) {
    // console.log("handleDialogPassword", id);
    !openPassword ? setSelectedId(id) : setSelectedId(null);
    setOpenPassword(!openPassword);
  };

  var handleItemDeleteInvoicePopover = function handleItemDeleteInvoicePopover(item, id) {
    var invoice = invoices.find(function (invoice) {
      return invoice._id === id;
    }); // console.log("handleItemViewInvoice invoice", invoice);

    setSelectedInvoice(invoice);
    handleDialogDeleteInvoice();
  };

  var handleItemDownloadInvoice = function handleItemDownloadInvoice(item, id) {
    console.log("handleItemDownloadInvoice item", item);
    var auxInvoices = [];
    var invoiceHandleToDownload = invoices.find(function (invoice) {
      return invoice._id === id;
    });

    if (invoiceHandleToDownload) {
      auxInvoices.push(invoiceHandleToDownload._id);
      handleSelectInvoicesToDownload(auxInvoices);
    }
  };

  var handleItemDuplicateInvoicePopover = function handleItemDuplicateInvoicePopover(item, id) {
    handleDuplicateInvoice(id);
  };

  var handleDialogDeleteInvoice = function handleDialogDeleteInvoice() {
    setOpenDeleteInvoice(!openDeleteInvoice);
  };

  var handleSelectInvoices = function handleSelectInvoices(type, selectedRows, displayData) {
    var auxInvoices = _.intersectionBy(displayData, selectedRows, "dataIndex").map(function (element) {
      return element.data[0];
    }); // console.log("handleSelectInvoices", auxInvoices);


    if (type === "download") {
      handleSelectInvoicesToDownload(auxInvoices);
    } else if (type === "send") {
      handleSelectInvoicesToSend(auxInvoices);
    }
  }; // eslint-disable-next-line no-unused-expressions


  columns ? columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return !centralView ? /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "invoices",
        labels: [{
          label: "View",
          name: "view",
          variant: "button",
          onItemClick: handleItemViewInvoice
        }, {
          label: "Edit",
          name: "edit",
          variant: "link",
          route: "/invoices/" + tableMeta.rowData[0] + "/edit"
        }, {
          label: "Download",
          name: "download",
          variant: "button",
          onItemClick: handleItemDownloadInvoice
        }, {
          label: "Delete",
          name: "delete",
          variant: "button",
          onItemClick: handleItemDeleteInvoicePopover
        }, {
          label: "Duplicate",
          name: "duplicate",
          variant: "button",
          onItemClick: handleItemDuplicateInvoicePopover
        }, {
          label: "Amend",
          name: "amend",
          variant: "button",
          onItemClick: handleItemAmendInvoicePopover
        }]
      }) : isCentralFranchiseView && /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "invoices",
        labels: [{
          label: "View",
          name: "view",
          variant: "button",
          onItemClick: handleItemViewInvoice
        }]
      });
    }
  } : null; // eslint-disable-next-line no-unused-expressions

  translation ? translation.datatable ? translation.datatable.invoices ? translation.datatable.invoices.columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "invoices",
        labels: [{
          label: translation.datatable.invoices.popovers.view || "View",
          name: "view",
          variant: "button",
          onItemClick: handleItemViewInvoice
        }, {
          label: translation.datatable.invoices.popovers.edit || "Edit",
          name: "edit",
          variant: "link",
          route: "/invoices/" + tableMeta.rowData[0] + "/edit"
        }, {
          label: translation.datatable.invoices.popovers.download || "Download",
          name: "download",
          variant: "button",
          onItemClick: handleItemDownloadInvoice
        }, {
          label: translation.datatable.invoices.popovers.download_face || "Descargar FACE",
          name: "downloadFace",
          variant: "button",
          onItemClick: handleItemDownloadFaceInvoicePopover
        }, {
          label: translation.datatable.invoices.popovers["delete"] || "Delete",
          name: "delete",
          variant: "button",
          onItemClick: handleItemDeleteInvoicePopover
        }, {
          label: translation.datatable.invoices.popovers.duplicate || "Duplicate",
          name: "duplicate",
          variant: "button",
          onItemClick: handleItemDuplicateInvoicePopover
        }, {
          label: translation.datatable.invoices.popovers.amend || "Amend",
          name: "amend",
          variant: "button",
          onItemClick: handleItemAmendInvoicePopover
        }]
      });
    }
  } : null : null : null;
  return [/*#__PURE__*/React.createElement(Dialog, {
    open: openDeleteInvoice,
    onClose: handleDialogDeleteInvoice,
    id: "modal-confirm-delete-opportunity",
    title: translation ? translation.dialogs.delete_invoice.title : "Delete invoice",
    text: translation ? translation.dialogs.delete_invoice.info : "Are you sure to delete this invoice? You will lose all information about this invoice",
    submit: translation ? translation.dialogs.delete_invoice.buttons["delete"] : "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDeleteInvoice,
    cancel: translation ? translation.dialogs.delete_invoice.buttons["delete"] : "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      handleDeleteInvoice(selectedInvoice);
      handleDialogDeleteInvoice();
    },
    translation: translation ? translation.dialogs.delete_invoice : null
  }), /*#__PURE__*/React.createElement(DialogViewInvoice, {
    historyView: isCentralFranchiseView,
    variant: "view",
    open: openView,
    onClose: function onClose() {
      setOpenView(false);
      setSelectedInvoice(null);
    },
    invoice: selectedInvoice,
    invoice_pdf: invoice_pdf,
    editStatus: editStatus,
    sendNotification: sendNotification,
    franchise: franchise,
    translation: translation ? translation.dialogs.view_invoice : null,
    locale: locale
  }), franchise && /*#__PURE__*/React.createElement(DialogCertificatePassword, {
    open: openPassword,
    onClose: function onClose() {
      setOpenPassword(false);
      setSelectedInvoice(null);
    },
    checkPassword: checkPassword,
    id: selectedId // translation={translation ? translation.dialogs.check_password : null}

  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: "#fafafa"
    }
  }, translation ? translation.title : "Invoices"), /*#__PURE__*/React.createElement(ButtonGroup, {
    color: "primary",
    "aria-label": "outlined primary button group"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: year === "2020" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2020");
    }
  }, "2020"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2021" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2021");
    }
  }, "2021"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2022" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2022");
    }
  }, "2022"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2023" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2023");
    }
  }, "2023"), /*#__PURE__*/React.createElement(Button, {
    variant: year === "2024" ? "contained" : "outlined",
    onClick: function onClick() {
      handleChangeYear("2024");
    }
  }, "2024")), /*#__PURE__*/React.createElement(Grid, null, (centralUser || franchise) && /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "contained",
    component: Link,
    to: "/add-invoice"
  }, translation ? translation.buttons.add_invoice : "+ Invoice"))), invoices && invoices.length > 0 ? /*#__PURE__*/React.createElement(FilterInvoicesList, {
    dashboard: dashboard,
    translation: translation ? translation : null,
    columns: columns,
    options: options,
    centralUser: centralUser,
    franchise: franchise,
    invoices: invoices,
    locale: locale,
    billingCentral: true,
    getFilteredInvoices: getFilteredInvoices,
    groupedByCategory: groupedByCategory,
    year: year,
    handleSelectYears: handleSelectYears,
    compareInvoices: compareInvoices,
    totals: totals
  }) : /*#__PURE__*/React.createElement(Skeleton, {
    height: 400
  }))];
};

export { InvoiceList };